import { Breadcrumbs } from "../components/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | ProfitMigo",
    description: "How ProfitMigo handles data: privacy-conscious analytics with consent, no personal data collection beyond what you provide, and how advertising would be handled if enabled.",
    path: "/privacy",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Privacy Policy" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Privacy Policy</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>Your privacy matters. This policy explains what we collect and why.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Calculator inputs</h2>
        <p>The numbers you type into a calculator are processed in your browser to show results instantly. We do not store them unless you explicitly choose "Save this calculation".</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Analytics</h2>
        <p>We use privacy-conscious, aggregate analytics to understand which calculators are useful (for example, page views and whether a calculator was used). These events are only recorded if you accept via the consent banner, and you can reject them without losing any functionality. We do not collect unnecessary personal data.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Advertising</h2>
        <p>No advertising network is currently active on ProfitMigo. If we introduce ads in future (for example Google AdSense), we will update this policy to name the network, describe what it collects and how to opt out, and personalized ad scripts will only load after you accept ad-personalization consent.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Cookies & local storage</h2>
        <p>We store your consent choice and any saved-calculation preferences in your browser's local storage. No third-party advertising cookies are set while ads are disabled.</p>

        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Contact</h2>
        <p>For any privacy questions, email hello@profitmigo.com.</p>
      </div>
    </div>
  );
}
